import { useContext, useEffect } from 'react';
import '../styles/ue_card.css';
import '../styles/ue_button.css';
import { StepContext } from './StepContext';

import mascotte from "../img/mascotte.png";
import mascotte_pianeta from "../img/mascotte_pianeta.png";


function UECard(props) {
    const { step, setStep } = useContext(StepContext);

    function selectMascotte(){
        if(props.mascotte==undefined){
            return mascotte; 
        }
        switch (props.mascotte) {
            case "none":
                return ""
                break;
                case "",null,undefined:
                    return ""
                    break;
                case "heart":
                    return mascotte_pianeta
                    break;        
            
            default:
                return mascotte;
        }
    }

    function NextStep(){
        if(props.onValidate){
            if(props.onValidate())
                setStep(step + 1)
        }else{
            setStep(step + 1)
        }
    }
    
    function PrevStep(){
       // if(props.onValidate())
            setStep(step - 1)
    }

    function BackButton(){
        if (props.BackButton){
            return <button className='ue btn btn-blue' onClick={() => { PrevStep() }}>Precedente</button>
        }
    }
    function NextButton(){
        if (props.NextButton){
            return <button className='ue btn btn-blue' onClick={() => { NextStep() }}>Continua</button>
        }
    }

    return (
        <div className={`step-card active ` + props.active} >
            {props.active}
            {props.children}

            

            <div style={{width: "100%",textAlign: "center",marginTop:"50px"}}>
                {BackButton()}
                {NextButton()}            
            </div>

            <img className="cardMascotte1" src={selectMascotte()}></img>
            
        </div>
    );
}



export default UECard;